import bongaPointsService from '../../api/bongapoints'

const state = {
}

const mutations = {
}

const actions = {
  retryTransaction ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      bongaPointsService.retryTransaction(payload).then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
